import { createStyles } from "antd-style";

export const useFieldSearchStyles = createStyles(({ css }: any) => ({
  root: css``,
}));
